import API from "api/API";
import useFetchData from "hooks/useFetchData";
import useAZZKULatestEditionID from "./useAZZKULatestEditionID";

export default function useAZZKUTopData( params ) {
   const edition_id = useAZZKULatestEditionID();
   return useFetchData({
      APIMethod: API.getAZZKUTopData,
      condition: !!edition_id,
      clear_data_on_update: true,
      debounce: true,
      params: [ edition_id, {
         variable_id: params.variable_id,
         year: params.year,
         voivodeship_ids: params.voivodeship_ids
      }]
   })
}